var $name="unknown",$path="configs/unknown.js",$this={$name,$path,};module.exports = {
  unknown: 'unknown',
};
